import { GeneratorTechnology, GeneratorTypeRef } from '@/dto/scenario/generator/GeneratorReference';
import { Genset } from '@/dto/scenario/generator/Genset';
import { DtoExt } from '@/classes/scenario/DtoExt';

export class GensetExt extends DtoExt {

  public static fromDto(dto: Genset): GensetExt {
    return new GensetExt({
      lifetimeHours: dto.lifetimeHours,
      fuelConsumptionAt25Percent: dto.fuelConsumptionAt25Percent,
      fuelConsumptionAt50Percent: dto.fuelConsumptionAt50Percent,
      fuelConsumptionAt75Percent: dto.fuelConsumptionAt75Percent,
      fuelConsumptionAt100Percent: dto.fuelConsumptionAt100Percent,
      optimumPercentage: dto.optimumPercentage,
      size: dto.size,
      typeRef: dto.typeRef,
      fromHour: dto.fromHour,
      toHour: dto.toHour,
      numberOfSimultaneous: dto.numberOfSimultaneous,
      numberOfSpares: dto.numberOfSpares,
      minimumGeneratorLoad: dto.minimumGeneratorLoad,
      quantity: dto.quantity,
      degradation: dto.degradation,
      fuelConsumptionKWhAt25Percent: dto.fuelConsumptionKWhAt25Percent,
      fuelConsumptionKWhAt50Percent: dto.fuelConsumptionKWhAt50Percent,
      fuelConsumptionKWhAt75Percent: dto.fuelConsumptionKWhAt75Percent,
      fuelConsumptionKWhAt100Percent: dto.fuelConsumptionKWhAt100Percent,
      efficiencyAt25Percent: dto.efficiencyAt25Percent,
      efficiencyAt50Percent: dto.efficiencyAt50Percent,
      efficiencyAt75Percent: dto.efficiencyAt75Percent,
      efficiencyAt100Percent: dto.efficiencyAt100Percent,
      sizeKW: dto.sizeKW,
      addOneThreshold: dto.addOneThreshold,
      rampUpTime: dto.rampUpTime,
      removeOneThreshold: dto.removeOneThreshold,
      srPriority: dto.srPriority,
      reference: dto.reference,
      pci: dto.pci,
      brand: dto.brand,
      technology: dto.technology
    } as any);
  }

  public lifetimeHours: number | null = null;

  public fuelConsumptionAt25Percent: number | null = null;
  public fuelConsumptionAt50Percent: number | null = null;
  public fuelConsumptionAt75Percent: number | null = null;
  public fuelConsumptionAt100Percent: number | null = null;

  // Multi only
  public fuelConsumptionKWhAt25Percent: number | null = null;
  public fuelConsumptionKWhAt50Percent: number | null = null;
  public fuelConsumptionKWhAt75Percent: number | null = null;
  public fuelConsumptionKWhAt100Percent: number | null = null;

  // Multi only
  public efficiencyAt25Percent: number | null = null;
  public efficiencyAt50Percent: number | null = null;
  public efficiencyAt75Percent: number | null = null;
  public efficiencyAt100Percent: number | null = null;

  public optimumPercentage: number | null = null;
  public size: number | null = null;
  public typeRef: GeneratorTypeRef | null = null;

  public fromHour: number | null = 0;
  public toHour: number | null = 24;

  public minimumGeneratorLoad: number | null = 0.3;

  public numberOfSimultaneous: number = 1; // NOT FED IN FRONT
  public numberOfSpares: number = 0; // NOT FED IN FRONT
  public quantity: number = 1; // NOT FED IN FRONT
  public degradation: number = 0; // NOT FED IN FRONT

  public technology: GeneratorTechnology | null = null;
  public brand: string | null = null;
  public sizeKW: number | null = null;
  public addOneThreshold: number | null = null;
  public rampUpTime: number | null = null;
  public removeOneThreshold: number | null = null;
  public srPriority: boolean | null = null;
  public reference: string | null = null;
  public pci: number | null = null;

  constructor(options?: Partial<GensetExt> | null) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
    }
  }

  public toDto(): Genset {
    return new Genset({
      lifetimeHours: this.lifetimeHours,
      fuelConsumptionAt25Percent: this.fuelConsumptionAt25Percent,
      fuelConsumptionAt50Percent: this.fuelConsumptionAt50Percent,
      fuelConsumptionAt75Percent: this.fuelConsumptionAt75Percent,
      fuelConsumptionAt100Percent: this.fuelConsumptionAt100Percent,
      optimumPercentage: this.optimumPercentage,
      size: this.size,
      typeRef: this.typeRef,
      fromHour: this.fromHour,
      toHour: this.toHour,
      numberOfSimultaneous: this.numberOfSimultaneous,
      numberOfSpares: this.numberOfSpares,
      minimumGeneratorLoad: this.minimumGeneratorLoad,
      quantity: this.quantity,
      degradation: this.degradation,
      fuelConsumptionKWhAt25Percent: this.fuelConsumptionKWhAt25Percent,
      fuelConsumptionKWhAt50Percent: this.fuelConsumptionKWhAt50Percent,
      fuelConsumptionKWhAt75Percent: this.fuelConsumptionKWhAt75Percent,
      fuelConsumptionKWhAt100Percent: this.fuelConsumptionKWhAt100Percent,
      efficiencyAt25Percent: this.efficiencyAt25Percent,
      efficiencyAt50Percent: this.efficiencyAt50Percent,
      efficiencyAt75Percent: this.efficiencyAt75Percent,
      efficiencyAt100Percent: this.efficiencyAt100Percent,
      sizeKW: this.sizeKW,
      addOneThreshold: this.addOneThreshold,
      rampUpTime: this.rampUpTime,
      removeOneThreshold: this.removeOneThreshold,
      srPriority: this.srPriority,
      reference: this.reference,
      pci: this.pci,
      brand: this.brand,
      technology: this.technology
    });
  }
}
